export default __webpack_public_path__ + "static/media/HouseIcon.70e373ab.svg";